import { getParentAppOrigin } from '../auth/embeddedTokenBridge';

// The chatbot host app shows this app under /hr-management (its path after that = ours).
const HOST_APP_HR_ROOT = '/hr-management';

type EmbedDetectionWindow = {
  self?: unknown;
  top?: unknown;
};

const TRUE_QUERY_VALUES = new Set(['1', 'true', 'yes']);
const FALSE_QUERY_VALUES = new Set(['0', 'false', 'no']);

export const resolveEmbeddedMode = (
  search: string,
  currentWindow: EmbedDetectionWindow | undefined = globalThis.window,
) => {
  const params = new URLSearchParams(search);
  const isIframeFlag = params.get('isIframe')?.trim().toLowerCase();

  if (isIframeFlag && TRUE_QUERY_VALUES.has(isIframeFlag)) {
    return true;
  }

  if (isIframeFlag && FALSE_QUERY_VALUES.has(isIframeFlag)) {
    return false;
  }

  if (!currentWindow) {
    return false;
  }

  try {
    return currentWindow.self !== currentWindow.top;
  } catch {
    return true;
  }
};

/**
 * Link to one of this app's pages that opens in a new tab: inside the host app's iframe it
 * points at the host app's page (so the tab stays in the host app), otherwise at our own path.
 */
export const resolveNewTabHref = (
  path: string,
  currentWindow: EmbedDetectionWindow | undefined = globalThis.window,
  parentOrigin: string = getParentAppOrigin(),
) => {
  if (!resolveEmbeddedMode('', currentWindow) || !parentOrigin) {
    return path;
  }

  return `${parentOrigin}${HOST_APP_HR_ROOT}${path}`;
};
